import { render, staticRenderFns } from "./tBulkImport.vue?vue&type=template&id=31fc57c8&scoped=true"
import script from "./tBulkImport.vue?vue&type=script&lang=js"
export * from "./tBulkImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fc57c8",
  null
  
)

export default component.exports